// LevelChips.jsx
// Memoized level selection chips

import React, {memo} from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import {getClassificationRank} from '../../helpers/documentClassification';

const LevelChips = memo(({levels, selectedLevel, minLevel, onLevelChange}) => {
    const minRank = getClassificationRank(minLevel);
    return (
        <Stack direction="row" gap={1} flexWrap="wrap" sx={{mb: 2}}>
            {levels.map((option) => {
                const isSelected = selectedLevel === option.value;
                const isDisabled = getClassificationRank(option.value) < minRank;
                const chip = (
                    <Chip
                        key={option.value}
                        label={option.label}
                        variant={isSelected ? 'filled' : 'outlined'}
                        disabled={isDisabled}
                        onClick={isDisabled ? undefined : () => onLevelChange(option.value)}
                        sx={{
                            borderColor: option.color,
                            color: isSelected ? '#FFFFFF' : option.color,
                            backgroundColor: isSelected ? option.color : option.bgColor,
                            '&:hover': {
                                backgroundColor: isSelected ? option.color : option.bgColor,
                                opacity: isSelected ? 0.9 : 0.8,
                            },
                        }}
                    />
                );
                return isDisabled ? (
                    <Tooltip key={option.value} title="Cannot be lower than the block's citation classification">
                        <span>{chip}</span>
                    </Tooltip>
                ) : chip;
            })}
        </Stack>
    );
});

LevelChips.displayName = 'LevelChips';

LevelChips.propTypes = {
    levels: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        color: PropTypes.string,
        bgColor: PropTypes.string,
    })).isRequired,
    selectedLevel: PropTypes.string.isRequired,
    minLevel: PropTypes.string,
    onLevelChange: PropTypes.func.isRequired,
};

export default LevelChips;

